import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { DirectoryDomain } from "src/app/models/directory/enums/DirectoryDomain.enum";
import { IDirectoryUser } from "src/app/models/directory/users/DirectoryUser";
import { WorkflowRequestTypes } from "src/app/models/requests/enums/WorkflowRequestTypes.enum";
import { CreatePrivilegeAccountRequest } from "src/app/models/servicePrivilegeAccounts/CreatePrivilegeAccountRequest";
import { CreateServiceAccountRequest } from "src/app/models/servicePrivilegeAccounts/CreateServiceAccountRequest";
import { DirectoryUserService } from "src/app/services/directory/DirectoryUser.service";

@Component({
    selector: 'request-details-user-create',
    templateUrl: './request-details-user-create.component.html'
})

export class RequestDetailsUserCreate implements OnChanges {
    @Input() requestData: CreateServiceAccountRequest | CreatePrivilegeAccountRequest | IDirectoryUser;
    @Input() workflowRequestType: WorkflowRequestTypes;

    @Output() doneLoading = new EventEmitter<boolean>();
    displayObject: any;

    constructor(
        private directoryUserService: DirectoryUserService,
    ) { }

    async ngOnChanges(): Promise<void> {

        let requestDetails: any = {

            userType: this.workflowRequestType === WorkflowRequestTypes.ServiceAccountCreate ? "Service" : "Privilege",
            stewardUserId: "",
            steward: "",
            userPrincipalName: "",
            usageLocation: "US",
            serviceId: ""
        };

        if ('emailId' in this.requestData) {
            requestDetails.userPrincipalName = this.requestData.emailId;
        } else if ('userPrincipalName' in this.requestData) {
            requestDetails.userPrincipalName = this.requestData.userPrincipalName;
        }

        if ('usageLocationCode' in this.requestData) {
            requestDetails.usageLocation = this.requestData.usageLocationCode;
        }
        else {
            delete requestDetails.usageLocation;
        }

        if ('stewardUserId' in this.requestData) {
            requestDetails.stewardUserId = this.requestData.stewardUserId;
        }
        if ('applicationId' in this.requestData) {
            requestDetails.serviceId = this.requestData.applicationId;
        } else if ('serviceId' in this.requestData) {
            requestDetails.serviceId = this.requestData.serviceId;
        }
        else {
            delete requestDetails.serviceId;
        }

        if (this.workflowRequestType !== WorkflowRequestTypes.PrivilegeAccountCreate) {
            const steward = await this.getSteward(requestDetails.stewardUserId);
            if (steward) {
                requestDetails.steward = steward.displayName;
            } else {
                requestDetails.steward = `unknown user with id '${requestDetails.stewardUserId}'`;
            }
        }
        else {
            delete requestDetails.steward;
        }
        delete requestDetails.stewardUserId;

        this.displayObject = { ...requestDetails };

        this.isDoneLoading();
    }

    async getSteward(stewardUserId: string) {

        try {
            const user = await this.directoryUserService.GetByIdAsync({ id: stewardUserId, domain: DirectoryDomain.Chevron });
            return user;
        }
        catch (error) {
            // not able to find the steward user, so we will just use the id
        }
        return undefined;
    }

    isDoneLoading() {
        this.doneLoading.emit(true);
    }
}
